// `application` sub-context shared between the initial LDProvider context and
// any subsequent client.identify() call, so flag rules that target
// `application.key` continue to match after login/identification.
export const LD_APPLICATION_CONTEXT = { key: 'marketplace' };
